import React, { useEffect } from 'react';
import MUIDataTable from "mui-datatables";
import { Chip, IconButton, Tooltip, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

export default function AssetsDataTable({ data, onEdit, onDelete }) {

    useEffect(()=>
        console.log('TABLE ASSETS ===> ',data)
    ,[data]);

    const columns = [
        {
            name: 'name',
            label: 'Nombre',
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'capacity',
            label: 'Capacidad',
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <Typography variant="body2">{value} Pers.</Typography>
                )
            }
        },
        {
            name: 'status',
            label: 'Estatus',
            options: {
                filter: true,
                customBodyRender: (value) => (
                    value === 1
                        ? <Chip label='Activo' color='success' size="small" />
                        : <Chip label='Inactivo' color='error' size="small" />
                )
            }
        },
        {
            name: 'id', // Usamos el ID para las acciones
            label: 'Acciones',
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex) => {
                    const rowData = data[dataIndex];
                    return (
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '10px' }}>
                            
                            <Tooltip title="Editar">
                                <IconButton onClick={() => onEdit(rowData)}>
                                    <FontAwesomeIcon icon={faEdit} size="sm"/>
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Eliminar">
                                <IconButton onClick={() => onDelete(rowData.id)}>
                                    <FontAwesomeIcon icon={faTrash} size="sm" color="#d32f2f"/>
                                </IconButton>
                            </Tooltip>
                        </div>
                    );
                }
            }
        }
    ];

    const options = {
        filterType: 'checkbox',
        selectableRows: 'none',
        responsive: 'standard', // 'standard', 'vertical', 'simple'
        rowsPerPage: 10,
        textLabels: {
            body: {
                noMatch: "No se encontraron activos registrados",
                toolTip: "Ordenar",
            },
            pagination: {
                next: "Siguiente Página",
                previous: "Página Anterior",
                rowsPerPage: "Filas por página:",
                displayRows: "de",
            },
            toolbar: {
                search: "Buscar",
                downloadCsv: "Descargar CSV",
                print: "Imprimir",
                viewColumns: "Ver Columnas",
                filterTable: "Filtrar Tabla",
            },
            filter: {
                all: "Todos",
                title: "FILTROS",
                reset: "REINICIAR",
            },
        }
    };

    return (
        <MUIDataTable
            title={"Listado de Activos Físicos"}
            data={data}
            columns={columns}
            options={options}
        />
    );
}